module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading.chartsIndex) ? _c('vue-spinner') : [void 0, _vm._v(" "), (_vm.chartsIndex.length === 0) ? _c('div', [_vm._v("\n      No charts exist. Add a Chart in the "), _c('router-link', {
    attrs: {
      "to": {
        'name': 'Reports View',
        'reportid': this.reportId,
        'hash': '#summary'
      }
    }
  }, [_vm._v("Summary")]), _vm._v(" tab.\n    ")], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.chartsIndex), function(chart, idx) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(chart.options.title))]), _vm._v(" "), (chart.type === 'pie') ? _c('pie-chart', {
      attrs: {
        "id": 'chrt' + idx,
        "options": chart.options,
        "chartdata": chart.chart_data,
        "show-counters": _vm.showCounters
      }
    }) : _vm._e(), _vm._v(" "), (chart.type === 'bar-vertical') ? _c('bar-chart', {
      attrs: {
        "id": 'chrt' + idx,
        "options": chart.options,
        "chartdata": chart.chart_data,
        "datalabels": _vm.showCounters
      }
    }) : _vm._e(), _vm._v(" "), (chart.type === 'bar-horizontal') ? _c('horizontal-bar-chart', {
      attrs: {
        "id": 'chrt' + idx,
        "options": chart.options,
        "chartdata": chart.chart_data,
        "datalabels": _vm.showCounters
      }
    }) : _vm._e(), _vm._v(" "), (chart.type === 'line') ? _c('line-chart', {
      attrs: {
        "id": 'chrt' + idx,
        "options": chart.options,
        "chartdata": chart.chart_data,
        "datalabels": _vm.showCounters
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_vm._v(" ")]), _vm._v(" "), _c('a', {
      attrs: {
        "id": 'download-png' + idx,
        "download": "chart.png"
      }
    }, [_c('button', {
      staticClass: "btn green",
      on: {
        "click": function($event) {
          return _vm.downloadPng(idx)
        }
      }
    }, [_vm._v("Download PNG")])]), _vm._v(" "), _c('router-link', {
      staticClass: "btn green pull-right",
      attrs: {
        "to": {
          name: 'Report Summary',
          params: {
            reportid: _vm.reportId,
            summaryId: chart.summary_id
          },
          hash: '#chart'
        },
        "tag": "button"
      }
    }, [_vm._v("\n        Edit Chart\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (_vm.chartsIndex.length > 1) ? _c('hr') : _vm._e()], 1)
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-761b59fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportCharts.vue
// module id = 1701
// module chunks = 1